export const linkChecker = {
  items: [
    {
      title: 'linkChecker.title',
      path: '/link-checker/list',
      icon: 'fa6-solid:link'
    }
  ]
};
